import Vue from 'vue'
import { Message } from 'element-ui'
import _ from 'lodash'
import axios from 'axios'
import i18n from '../i18n/i18n'

export function formatFile(file, key) {
	let formData = new FormData()
	formData.append(key, file)
	return formData
}

export function getType(o) {
	return Object.prototype.toString.call(o).slice(8, -1)
}


export function getCookie(name) {
	let cookieStr = document.cookie
	let start, end
	if (cookieStr.length > 0) {
		start = cookieStr.indexOf(name + '=')
		if (start > -1) {
			start += name.length + 1
			end = cookieStr.indexOf(';', start)
			if (end === -1) {
				end = cookieStr.length
			}
		} else if (start == -1) {
			return ''
		}
		return decodeURIComponent(cookieStr.slice(start, end))
	}
	return ''
}

export function setCookie(name, value, time, domain, path) {
	var str = name + '=' + encodeURIComponent(value)
	if (time) {
		var date = new Date(time).toUTCString()
		str += ';expires=' + date
	}
	str = domain ? str + ';domain=' + domain : str
	str = path ? str + ';path=' + path : str
	document.cookie = str
}

export function setCheckedNodes(data, key) {
	let result = []
	data.forEach((node) => {
		if (node[key]) {
			result.push(node)
		}
		if (node.children && getType(node.children) == 'Array') {
			let nodes = setCheckedNodes(node.children, key)
			result = result.concat(nodes)
		}
	})
	return result
}

export function loopTree(data, callback) {
	if (getType(data) === 'Array') {
		data.forEach((node) => {
			callback && callback(node, data)
			if (node.children) {
				loopTree(node.children, callback)
			}
		})
	} else {
		return []
	}
}

export function loopTreeV2(data, parNode, callback) {
	if (getType(data) === 'Array') {
		data.forEach((node) => {
			callback && callback(node, parNode, callback)
			if (node.children) {
				loopTreeV2(node.children, node, callback)
			}
		})
	}
}

export function getTreePath(data, key, value) {
	console.log(data);
	let path = [];
	function getPath(data, key, value, level = 0) {
		// 遍历树节点
		for(let i = 0; i< data.length; i++ ){
			if(data[i].children) {
				let pathFlag = getPath(data[i].children, key, value, i) 
				if(pathFlag) {
					path.unshift(data[i]);
					return true;
				}
			}
			if(data[i][key] == value) {
				path.unshift(data[i]);
				return true;
			}
		}
	}
	getPath(data, key, value)
	return path
}

export function filterEmptyNode(data) {
	let children = []
	children = data.children.filter((node) => {
		if (node.children) {
			filterEmptyNode(node)
		}
		return node.resourceId
	})
	data.children = children
	return data
}

export function toTree(source, id, parentId, children, isMenu=true) {
	let cloneData = _.cloneDeep(source)
	let result = []
	result = cloneData.filter((father) => {
		//利用了数据是引用类型的特点
		let branchArr
		if(isMenu) {
			branchArr = cloneData.filter((child) =>  father[id] == child[parentId])
		}  else {
			branchArr = cloneData.filter((child) => ['0','1'].includes(child.type) && father[id] == child[parentId])
		}
		branchArr.length > 0 ? (father[children] = branchArr) : ''
		return !father[parentId] // 如果第一层不是parentId=0，请自行修改
	})
	console.log(result)
	if(result.length) {
		return result;
	} else {
		return cloneData
	}
}

// 判断是否有值
export function hasValue(str) {
	if (str == undefined || str == null) {
		return false
	}
	if (typeof str == 'string' && str.trim().length == 0) {
		return false
	}
	return true
}

// 判断数组是否连续
export function isContinuityNum(num) {
	let array = []
	if (num instanceof Array) {
		array = [...num]
	} else {
		array = Array.from(num.toString()) //转换为数组
	}

	var i = array[0]
	var isContinuation = true
	for (var e in array) {
		if (array[e] != i) {
			isContinuation = false
			break
		}
		i++
	}
	return isContinuation
}

// 找到节点为open状态的第一个节点
export function getOpenNode_(tree, node = [], level = 1) {
	tree.some(o => {
		o.level = level
		if (o.open && (!node.length || o.level < node[0].level)) {
			node = [o]
		}
		if (o.children && !node.length) {
			let childRes = getOpenNode_(o.children, node, level + 1)
			node = childRes.length ? childRes : node
		}
	})
	if (!node.length) return []
	else return node
}

export function getOpenNode(tree, key) {
	if (key) return getOpenNode_(tree).map(o => o[key])
	else return getOpenNode_(tree)
}

// 下载文件：返回blob
export async function downloadBlobFile(config) {
	let requestConfig = {
		method: config.method,
		url: config.url,
		timeout: 120 * 1000,
		responseType: 'blob',
		headers: {
			Authorization: Vue.$cookies.get('_a') || sessionStorage.getItem('_a'),
			...config.headers,
		},
	}
	config.params ? (requestConfig.params = config.params) : ''
	config.data ? (requestConfig.data = config.data) : ''
	let res = (await axios(requestConfig).catch((err) => {
		console.log(err);
	  }))
	if (!res) {
		Vue.prototype.$message.error(
			i18n.t("downloadFailed")
		)
		return;
	}
	if (res.data && res.data.type == 'application/json') {
		//异常返回application/json
		const reader = new FileReader()
		reader.readAsText(res.data, 'utf-8')
		reader.onload = (event) => {
			let err = JSON.parse(event.target.result)
			if (err.code != 1) {
				Vue.prototype.$message.error(
					err.result ? err.result : err.msg ? err.msg : this.$t("downloadFailed")
				)
			}
		}
	} else {
		//正常返回文件流
        let blobObj, link;
        let disposition = res.headers['content-disposition']
        if (!disposition) {
            Message.warning('暂无可下载的文件！')
            console.log('暂无可下载的文件！')
            return
        }
        let fileName = config.fileName || decodeURIComponent(disposition.split('=')[1]) // 获取文件名
		if (typeof window.chrome !== 'undefined') {
			//谷歌
			blobObj = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
			// blobObj = new Blob([res.data], { type: 'application/vnd.ms-excel' })
			link = document.createElement('a')
			link.href = window.URL.createObjectURL(blobObj)
			link.download = fileName
			link.click()
		} else if (typeof window.navigator.msSaveBlob !== 'undefined') {
			//IE
			blobObj = new Blob([res.data], { type: 'application/force-download' })
			window.navigator.msSaveBlob(blobObj, fileName)
		} else {
			//火狐
			blobObj = new File([res.data], fileName, {
				type: 'application/force-download',
			})
			window.open(URL.createObjectURL(blobObj))
		}
		return {
			code: '1',
            // message: this.$t("downloadSuccessful")
		}
	}
}

// pdf文件预览，返回url
export async function getPdfUrl(config) {
    let resultFileUrl = ''
	let requestConfig = {
		method: config.method,
		url: config.url,
		responseType: 'blob',
		headers: config.headers ? config.headers : {},
	}
	config.params ? (requestConfig.params = config.params) : ''
	config.data ? (requestConfig.data = config.data) : ''
	let res = (await axios(requestConfig)) || {}
	if (res.data && res.data.type == 'application/json') {
		//异常返回application/json
		const reader = new FileReader()
		reader.readAsText(res.data, 'utf-8')
		reader.onload = (event) => {
			let err = JSON.parse(event.target.result)
			if (err.code != 1) {
				Vue.prototype.$message.error(
					err.result ? err.result : err.message ? err.message : this.$t("downloadFailed")
				)
			}
		}
	} else {
		//正常返回文件流
		let blobObj, link, defaultFileName;
        let disposition = res.headers['content-disposition']
        if (!disposition) {
            // Message.warning('暂无文件！')
            // console.log('暂无文件！')
			// return
			defaultFileName = `Executive goal Preview`
        }
        let fileName = defaultFileName ||  config.fileName || decodeURIComponent(disposition.split('=')[1]) // 获取文件名
		if (typeof window.chrome !== 'undefined') {  //谷歌
			blobObj = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
		} else if (typeof window.navigator.msSaveBlob !== 'undefined') { //IE
			blobObj = new Blob([res.data], { type: 'application/force-download' })
		} else { //火狐
			blobObj = new File([res.data], fileName, {
				type: 'application/force-download',
			})
        }
        resultFileUrl = window.URL.createObjectURL(blobObj)
		return {
			code: '1',
            resultFileUrl
		}
	}
}

export function filterOpenNodes(data) {
	function loop(data) {
		return data.filter(node => {
			if(node.children) {
				node.children = loop(node.children);
			}
			return node.open
		})
	}
	let result = loop(data);
	return result;
}

export function setLanguage(langList){
	// 判断语言类型 
	/**
	 * 语言的优先顺序  简体>繁体>英文
		例如：如果只填写了简体，未填写繁体和英文，保存或提交时繁体和英文都取成简体；如果填了繁体和英文，那么简体中文取填充成繁体。
	 */
	let currentLang;
	// 没有简体 返回繁体  没有繁体 返回英文  没有英文 返回undefined
	for(let i = 0; i< langList.length ;i ++) {
		// 传入顺序简体 繁体 英文
		if(langList[i] && !currentLang) {
			currentLang = langList[i]
		}
	}
	return currentLang
}

export function fillLanguage(langMap) {
	let currentLang = setLanguage(Object.keys(langMap).map(key => langMap[key]));
	console.log(currentLang)
	let result = {};
	Object.keys(langMap).forEach(key => {
		if(!langMap[key]) {
			langMap[key] = currentLang;
		}
		result[key] = langMap[key];
	})
	return result;
}

export function checkStr(str) {
    if (str === undefined || str === null) {
        return false
    }
    if (typeof str === 'string' && str.trim().length == 0) {
        return false
    }
    return true
}


export async function getFilesNames(ids) {
	return new Promise((resolve, reject) => {
		const promiseGroup = [];
		ids.forEach( async (id) => {
			promiseGroup.push(
				new Promise((resolve, reject) => {
					axios({
						url: '/app/sys/file/download',
						params: {
							fileId: id
						}	
					}).then(res => {
						resolve(res);
					})
				})
			)
		}) 
		Promise.all(promiseGroup).then( responseList => {
			console.log(responseList)
			let names = responseList.map(res => {
				let headers = res.headers
				return headers['content-disposition'].slice(20)
			})
			resolve(names);
		})
	})
}

export function floatObj () {
    
    /*
     * 判断obj是否为一个整数
     */
    function isInteger(obj) {
        return Math.floor(obj) === obj
    }
    
    /*
     * 将一个浮点数转成整数，返回整数和倍数。如 3.14 >> 314，倍数是 100
     * @param floatNum {number} 小数
     * @return {object}
     *   {times:100, num: 314}
     */
    function toInteger(floatNum) {
        var ret = {times: 1, num: 0}
        var isNegative = floatNum < 0
        if (isInteger(floatNum)) {
            ret.num = floatNum
            return ret
        }
        var strfi  = floatNum + ''
        var dotPos = strfi.indexOf('.')
        var len    = strfi.substr(dotPos+1).length
        var times  = Math.pow(10, len)
        var intNum = parseInt(Math.abs(floatNum) * times + 0.5, 10)
        ret.times  = times
        if (isNegative) {
            intNum = -intNum
        }
        ret.num = intNum
        return ret
    }
    
    /*
     * 核心方法，实现加减乘除运算，确保不丢失精度
     * 思路：把小数放大为整数（乘），进行算术运算，再缩小为小数（除）
     *
     * @param a {number} 运算数1
     * @param b {number} 运算数2
     * @param digits {number} 精度，保留的小数点数，比如 2, 即保留为两位小数
     * @param op {string} 运算类型，有加减乘除（add/subtract/multiply/divide）
     *
     */
    function operation(a, b, digits, op) {
        var o1 = toInteger(a)
        var o2 = toInteger(b)
        var n1 = o1.num
        var n2 = o2.num
        var t1 = o1.times
        var t2 = o2.times
        var max = t1 > t2 ? t1 : t2
        var result = null
        switch (op) {
            case 'add':
                if (t1 === t2) { // 两个小数位数相同
                    result = n1 + n2
                } else if (t1 > t2) { // o1 小数位 大于 o2
                    result = n1 + n2 * (t1 / t2)
                } else { // o1 小数位 小于 o2
                    result = n1 * (t2 / t1) + n2
                }
                return result / max
            case 'subtract':
                if (t1 === t2) {
                    result = n1 - n2
                } else if (t1 > t2) {
                    result = n1 - n2 * (t1 / t2)
                } else {
                    result = n1 * (t2 / t1) - n2
                }
                return result / max
            case 'multiply':
                result = (n1 * n2) / (t1 * t2)
                return result
            case 'divide':
                result = (n1 / n2) * (t2 / t1)
                return result
        }
    }
    
    // 加减乘除的四个接口
    function add(a, b, digits) {
        return operation(a, b, digits, 'add')
    }
    function subtract(a, b, digits) {
        return operation(a, b, digits, 'subtract')
    }
    function multiply(a, b, digits) {
        return operation(a, b, digits, 'multiply')
    }
    function divide(a, b, digits) {
        return operation(a, b, digits, 'divide')
    }
    
    // exports
    return {
        add: add,
        subtract: subtract,
        multiply: multiply,
        divide: divide
    }
}


